var app_google_integrations_table = $('#app-google-integrations-table');

if (app_google_integrations_table.length) {
    console.log("here1");
    var isFromAdvertiser = app_google_integrations_table.data('advertiser');
    if (typeof isFromAdvertiser !== 'undefined' && isFromAdvertiser !== null) {
        isFromAdvertiser = '?advertiser=' + adv_id;
    } else {
        isFromAdvertiser = '';
    }
    function init_google_integrations_table() {
        console.log("here2");
        window.app_google_integrations_table
            .DataTable({
                ajax: {
                    url: '/oauth/google/list' + isFromAdvertiser,
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'email'},
                    {data: 'name'},
                    {data: 'created_at'}
                ],
                destroy: true,
                "columnDefs": [{
                    "targets": 2,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(moment(cellData, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YY hh:mm a'));
                    }
                }]
            });
    }

    init_google_integrations_table();
}else{
    console.log("problem google");
}

var app_quickbooks_integrations_table = $('#app-quickbooks-integrations-table');

if (app_quickbooks_integrations_table.length) {
    console.log("here1");
    function init_quickbooks_integrations_table() {
        console.log("here2");
        window.app_quickbooks_integrations_table
            .DataTable({
                ajax: {
                    url: '/oauth/quickbooks/list',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'email'},
                    {data: 'name'},
                    {data: 'created_at'},
                    {data: 'default_item_value'}
                ],
                destroy: true,
                "columnDefs": [{
                    "targets": 2,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(moment(cellData, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YY hh:mm a'));
                    }
                },{
                    "targets": 3,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '<select id="' + rowData.email + '|items" name="default_items[]" class="full-width form-control default-quickboo-item"><option value="">-- Select Default Item --</option>';
                        if(typeof quickbook_items[rowData.account_id] !== 'undefined') {
                            for (var realmId in quickbook_items[rowData.account_id]) {
                                if(quickbook_items[rowData.account_id][realmId]['Active'])
                                    html += '<option ' + (rowData.default_item_value === quickbook_items[rowData.account_id][realmId]['Id'] ? 'selected' : '') + ' value="' + quickbook_items[rowData.account_id][realmId]['Name'] + '|||' + quickbook_items[rowData.account_id][realmId]['Id'] + '">' + quickbook_items[rowData.account_id][realmId]['Name'] + '</option>';
                            }
                        }
                        html += '</select>';
                        $(td).html(html);
                    }
                }]
            });
    }

    init_quickbooks_integrations_table();

    $(document).on('change', '.default-quickboo-item', function(){
        console.log('value: ', $(this).val());
        if($(this).val() !== "") {
            var params = {
                name: $(this).val().split('|||')[0],
                value: $(this).val().split('|||')[1],
                email: $(this).attr('id').split('|')[0]
            };
            show_loader();
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/agency/default-item/save',
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    console.log("response", response);
                    if (typeof response['error'] !== 'undefined') {
                        global_notification('error', response['error']);
                    } else {
                        global_notification('success', "Default item saved.");
                    }
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    })
}else{
    console.log("problem quickbooks");
}

var app_centro_integrations_table = $('#app_centro_integrations_table');

if (app_centro_integrations_table.length) {
    console.log("here1");
    function init_centro_integrations_table() {
        console.log("here2");
        window.app_centro_integrations_table
            .DataTable({
                ajax: {
                    url: '/oauth/centro/list',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'name'},
                    {data: 'created_at'}
                ],
                destroy: true,
                "columnDefs": [{
                    "targets": 1,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(moment(cellData, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YY hh:mm a'));
                    }
                }]
            });
    }

    init_centro_integrations_table();

    console.log("ready");
    $('#submit_centro_credentials').on('click', function(){
        if($('#centro_client_id').val().trim() !== "" && $('#centro_client_secret').val().trim() !== '' && $('#centro_client_name').val().trim() !== '' && $('#centro_client_adv_id').val().trim() !== '') {
            show_overlay_loader($('#centro_auth_modal .modal-content'));
            var params = {
                client_id: $('#centro_client_id').val(),
                client_secret: $('#centro_client_secret').val(),
                centro_name: $('#centro_client_name').val(),
                advertiser_id: $('#centro_client_adv_id').val()
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/oauth/centro/login',
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    console.log("response", response);
                    if (typeof response['error'] !== 'undefined') {
                        global_notification('error', response['error']);
                    } else {
                        global_notification('success', "Your Centro account has been successfully integrated.");
                        $("#centro_auth_modal").modal('hide');
                        init_centro_integrations_table();
                    }
                    hide_overlay_loader($('#centro_auth_modal .modal-content'));
                },
                error: function (xhr) {
                    hide_overlay_loader($('#centro_auth_modal .modal-content'));
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }else{
            global_notification('error', 'Please complete required fields!');
        }
    });

}else{
    console.log("problem centro");
}



var app_workamajig_integrations_table = $('#app_workamajig_integrations_table');

if (app_workamajig_integrations_table.length) {
    console.log("here1");
    function init_workamajig_integrations_table() {
        console.log("here2");
        window.app_workamajig_integrations_table
            .DataTable({
                ajax: {
                    url: '/oauth/workmajig/list',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'user_name'},
                    {data: 'created_at'},
                    {data: 'id'},
                ],
                destroy: true,
                "columnDefs": [{
                    "targets": 1,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(moment(cellData, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YY hh:mm a'));
                    }
                }, {
                    "targets": 2,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '<div class="row text-center " style=""><div class="btn-group " role="group" >' +
                            '<a  href="javascript:void(0)" role="button" data-id="'+ rowData.id +'" class="btn btn-success btn-sm btn-outline workamajig_user_integration_edit">' +
                            '<i class="fa fa-pencil"></i> Edit' +
                            '</a>' ;
                        html+=   '<a  href="javascript:void(0)" role="button" data-id="'+ rowData.id +'" class="btn btn-danger btn-sm btn-outline workamajig_user_integration_delete">' +
                            '<i class="fa fa-trash-o"></i> Delete' +
                            '</a>';

                        html+='</div></div>';
                        $(td).html(html);
                    }
                }]
            });
    }

    init_workamajig_integrations_table();
    //workamajig_auth_modal
    $('#app_workamajig_integrations_table').on('click', '.workamajig_user_integration_edit', function (){
       var integration_id = $(this).attr('data-id');
        $.ajax({
            type: 'GET',
            url: '/workamajig_integrations/users/edit/' + integration_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#workamajig_user_edit').html('<option selected value="'+ data.user_id +'"> '+data.user_name+' </option>');
                $('#workamajig_user_edit').attr('disabled', 'disabled')
                $('#workamajig_api_token_edit').val(data.api_token);
                $('#workamajig_user_token_edit').val(data.user_token);
                $('#workamajig_client_name_edit').val(data.subdomain);
                $('#submit_workamajig_credentials_edit').attr('data-id', integration_id);
                $('#workamajig_auth_modal_edit').modal('show');
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
                $('#loading_saving').css("display", "none");
            }
        });
    });

    $('#submit_workamajig_credentials_edit').on('click', function (){
        show_overlay_loader('#workamajig_auth_modal_edit');
        var params = {
            id : $('#submit_workamajig_credentials_edit').attr('data-id'),
            api_token : $('#workamajig_api_token_edit').val(),
            user_token : $('#workamajig_user_token_edit').val(),
            subdomain : $('#workamajig_client_name_edit').val(),
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/workamajig_integrations/users/update',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                hide_overlay_loader('#workamajig_auth_modal_edit');
                $('#workamajig_auth_modal_edit').modal('hide');
                global_notification('success', "Workamajig user integration updated successfully.")
            },
            error: function (xhr) {
                hide_overlay_loader('#workamajig_auth_modal_edit');
                debug(xhr.responseText);
                ajax_error();

            }
        });
    });
    $('#app_workamajig_integrations_table').on('click', '.workamajig_user_integration_delete', function (){
        var integration_id = $(this).attr('data-id');
        swal({
                title: "Warning",
                text: 'Are you sure to delete this user integration?',
                type: "warning",
                 showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                 cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
             if(isConfirm) {
                 show_overlay_loader('#workamajig_auth_modal_edit');
                 $.ajax({
                     type: 'GET',
                     url: '/workamajig_integrations/users/delete/' + integration_id,
                     dataType: 'json',
                     encode: true,
                     success: function (data) {
                         hide_overlay_loader('#workamajig_auth_modal_edit');
                         global_notification('success', "Workamajig user integration deleted successfully.")
                         init_workamajig_integrations_table();
                         $('#workamajig_auth_modal_edit').modal('hide');
                     },
                     error: function (xhr) {
                         hide_overlay_loader('#workamajig_auth_modal_edit');
                         debug(xhr.responseText);
                     }
                 });
             }
            });

    });

}else{
    console.log("problem workamajig");
}
